import * as z from 'zod';

import { domainQuerySchema } from './domain-query-schema';

export const domainMutationSchema = domainQuerySchema
  .pick({
    id: true,
    name: true,
    registrar_id: true,
    infrastructure_id: true,
    client_id: true,
    application_id: true,
    hosting_management: true,
    registrar_management: true,
  })
  .extend({
    dns_management: z.string(),
    registrar_username: z.string(),
    registrar_password: z.string(),
    registrar_pin: z.string(),
    expiration_date: z.string(),
    registrar_notes: z.string(),

    deployment_path: z.string(),
    hosting_notes: z.string(),
    creator_id: z.number().optional(),
  });

export type DomainMutationSchema = z.infer<typeof domainMutationSchema>;

export const domainCreateSchema = domainMutationSchema.omit({
  id: true,
});

export type DomainCreateSchema = z.infer<typeof domainCreateSchema>;
